import type { TagGroup } from "../../data/site";
import { Card } from "../ui/Card";
import "./skills.css";

export function Skills({ groups }: { groups: TagGroup[] }) {
  return (
    <div className="skills">
      {groups.map((g) => (
        <Card key={g.title}>
          <div className="skills__title">{g.title}</div>
          <div className="skills__items">
            {g.items.map((name) => (
              <div className="skill skill--tag" key={name}>
                <div className="skill__name">{name}</div>
              </div>
            ))}
          </div>
        </Card>
      ))}
    </div>
  );
}

